import { Approver } from "../../../Reusables/components/ClientApproverSetting/ClientApproverSetting.utils";

/**
  * Compares two lists of approvers and checks if they are equal.
  * Equality is determined by comparing the `FirmDetailId` of each approver after sorting.
  *
  * @param a - The first list of approvers.
  * @param b - The second list of approvers.
  * @returns `true` if both lists contain the same approvers in any order, otherwise `false`.
  */
export const areApproversEqual = (a: Approver[], b: Approver[]): boolean => {
  if (a.filter((approver) => approver.Active === "Y").length !== b.filter((approver) => approver.Active === "Y").length) return false;

  const sortById = (list: Approver[]) =>
    [...list].sort((x, y) => (x.FirmDetailId ?? 0) - (y.FirmDetailId ?? 0));

  const sortedA = sortById(a);
  const sortedB = sortById(b);

  return sortedA.every(
    (item, index) => item.FirmDetailId === sortedB[index].FirmDetailId && item.Active === sortedB[index].Active
  );
};